<template>
<div>
  <article class="tile is-child box" v-if="parseInt($store.state.config.user.level) < 99 && (financials.length > 0 || service.invoice || service.payment)">
    <h4 class="title">Charges V1</h4>
    <div class="columns is-multiline">
      <div class="column is-12">
        <table v-if="financials.length > 0" class="table is-striped is-narrow">
          <thead>
          <tr class="is-primary">
            <th>#</th>
            <th>System</th>
            <th>Type</th>
            <th>Client Price</th>
            <th>Provider Price</th>
            <th>Status</th>
            <th>Pay</th>
            <th>Charge Date</th>
            <th>Invoice/Pay Order</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="financial in financials">
            <td>{{ financial.id }}</td>
            <td style="text-align:center">{{parseSystem(financial)}}</td>
            <td v-if="financial.type == 1">Credit</td>
            <td v-if="financial.type == 2">Debit</td>
            <td>{{ financial.gross_price }} {{ financial.gross_currency }}</td>
            <td>{{ financial.net_price }} {{ financial.net_currency }}</td>
            <td v-if='financial.status == 1'>Active</td>
            <td v-if='financial.status == 0'>Voided</td>
            <td v-if='financial.pay == 0'>Supplier</td>
            <td v-if='financial.pay == 1'>Direct</td>
            <td v-if='financial.pay == 2'>T4W</td>
            <td>{{financial.charge_at}}</td>
              <td><template v-if="financial.invoice_financials"><a @click="openInvoice(financial.invoice_financials.invoice_id)">{{financial.invoice_financials.invoice_id}}</a></template><template v-else>No</template>/<template v-if="financial.payment_financials"><a @click="openPayment(financial.payment_financials.payment_id)">{{financial.payment_financials.payment_id}}</a></template><template v-else>No</template></td>
            <td>

              <tooltip :label="financial.observation" type="default" placement="left">
                <a class="button button-table is-small">
                  <i class="fa fa-eye"></i>
                </a>
              </tooltip>
              <tooltip v-if="show(financial) && parseInt(financial.user_id) !== 1" :label="financials.status" type="default"  placement="left">
                <a class="button button-table is-small" @click="voided(financial.id)">
                  <i class="fa fa-times"></i>
                </a>
              </tooltip>
              <tooltip label="Refresh" type="default"  placement="left">
                <a class="button button-table is-small" @click="refresh(financial.id)">
                  <i class="fa fa-refresh"></i>
                </a>
              </tooltip>
              <tooltip v-if="show(financial) && parseInt(financial.refund) === 0" :label="financials.editing" type="default"  placement="left">
                <a class="button button-table is-small" @click="editOperation(financial.id)">
                  <i class="fa fa-pencil"></i>
                </a>
              </tooltip>
              <tooltip v-if="showCreateInvoicePayment(financial)" label="Create Invoice/Payment Order" type="default"  placement="left">
                <a class="button button-table is-small" @click="createInvoicePayment(financial)">
                  <i class="fa fa-asterisk"></i>
                </a>
              </tooltip>
              <tooltip label="Skip" type="default" placement="left" v-if="(parseInt(financial.skip_client) == 0 || parseInt(financial.skip_provider) == 0) && (show(financial) && parseInt(financial.user_id) !== 1)">
                <a class="button button-table is-small" @click="skip(financial)">
                  <i class="fa fa-arrow-right"></i>
                </a>
              </tooltip>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="card is-fullwidth">
          <header class="card-header">
            <p class="card-header-title is-primary">{{operation}}</p>
          </header>
          <div class="card-content">
            <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
            <div class="content">
              <div class="control is-grouped">
                <div style="width: 100px;" class="control">
                  <label class="label">Charge Date</label>
                  <datepicker ref="charge_at"></datepicker>
                </div>
                <div style="width: 100px;" class="control">
                <label class="label">Pay</label>
                <select class="select is-fullwidth" v-model="financial.pay" name="pay" id="pay" :class="{'is-disabled': parseInt(financial.user_id) == 1}">
                  <option value='0'>Supplier</option>
                  <option value='1'>Direct</option>
                  <option value='2'>T4W</option>
                </select>
                </div>
                <template v-if="financial.pay < 2">
                  <div style="width: 100px;" class="control">
                    <label class="label">Invoice</label>
                    <input :class="{'input': true, 'is-danger': errors.has('invoice')}" name="invoice" id="invoice" type="text" placeholder="" v-model="financial.invoice">
                    <span v-show="errors.has('invoice')" class="help is-danger">{{ errors.first('invoice') }}</span>
                  </div>
                  <div style="width: 100px;" class="control">
                    <label class="label">Pay Order</label>
                    <input :class="{'input': true, 'is-danger': errors.has('payment')}" name="payment" id="payment" type="text" placeholder="" v-model="financial.payment" >
                    <span v-show="errors.has('payment')" class="help is-danger">{{ errors.first('payment') }}</span>
                  </div>
                </template>
              </div>
              <div class="control is-vertical">
                <div class="control">
                  <textarea :class="{'textarea': true, 'is-danger': errors.has('observation'), 'is-disabled': parseInt(financial.user_id) == 1}" name="observation" id="observation" placeholder="" v-model="financial.observation" v-validate="'required'"></textarea>
                  <span v-show="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</span>
                </div>
              </div>
              <div class="control is-grouped">
                <p class="control is-expanded">
                  <label class="label">Type</label>
                  <select class="select is-fullwidth" v-model="financial.type" name="type" id="type" :class="{'is-disabled': parseInt(financial.user_id) == 1}">
                    <option value='1'>Credit</option>
                    <option value='2'>Debit</option>
                  </select>
                </p>
                <p class="control is-expanded">
                  <label class="label">Client Price</label>
                  <input :class="{'input': true, 'is-danger': errors.has('gross_price'), 'is-disabled': parseInt(financial.user_id) == 1 || parseInt(financial.pay) == 1}" name="gross_price" id="gross_price" type="text" placeholder="" v-model="financial.gross_price" v-validate="{ required: parseInt(financial.pay) ==! 1, decimal: true }">
                  <span v-show="errors.has('gross_price')" class="help is-danger">{{ errors.first('gross_price') }}</span>
                </p>
                <p class="control is-expanded">
                  <label class="label">Provider Price</label>
                  <input :class="{'input': true, 'is-danger': errors.has('net_price'), 'is-disabled': parseInt(financial.user_id) == 1}" name="net_price" id="net_price" type="text" placeholder="" v-model="financial.net_price" v-validate="'required|decimal'">
                  <span v-show="errors.has('net_price')" class="help is-danger">{{ errors.first('net_price') }}</span>
                </p>
                <p class="control is-expanded" v-show="parseInt(financial.pay) === 1">
                  <label class="label">Currency</label>
                  <select class="select is-fullwidth" v-model="financial.currency" name="currency" id="currency" v-validate="{ required: parseInt(financial.pay) === 1}" :class="{'is-danger': errors.has('net_price')}">
                    <option value="BRL">BRL</option>
                    <option value="USD">USD</option>
                    <option value="EUR">EUR</option>
                    <option value="AUD">AUD</option>
                    <option value="CAD">CAD</option>
                    <option value="MXN">MXN</option>
                    <option value="GBP">GBP</option>
                    <option value="ARS">ARS</option>
                    <option value="ZAR">ZAR</option>
                    <option value="THB">THB</option>
                  </select>
                  <span v-show="errors.has('currency')" class="help is-danger">{{ errors.first('currency') }}</span>
                </p>
                <a :class="{'button': true, 'is-primary': true, 'is-pulled-right': true, 'is-loading': inProgress, 'is-disabled': errors.any() || inProgress}" @click="save" style="margin-top: 24px;">Save</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
  <br v-if="financials.length > 0 || service.invoice || service.payment">
  <article class="tile is-child box" v-if="parseInt($store.state.config.user.level) < 99">
    <h4 class="title">Charges V2</h4>
    <div class="columns is-multiline">
      <div class="column is-12">
        <table v-if="financialsV2.length > 0" class="table is-striped is-narrow">
          <thead>
          <tr class="is-primary">
            <th>#</th>
            <th>System</th>
            <th>Type</th>
            <th>Client Price</th>
            <th>Provider Price</th>
            <th>Status</th>
            <th>Pay</th>
            <th>Charge Date</th>
            <th>Invoice/Pay Order</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="financial in financialsV2">
            <td>{{ financial.id }}</td>
            <td style="text-align:center">{{parseSystem(financial)}}</td>
            <td v-if="financial.type == 1">Credit</td>
            <td v-if="financial.type == 2">Debit</td>
            <td>{{ financial.gross_price }} {{ financial.gross_currency }}</td>
            <td>{{ financial.net_price }} {{ financial.net_currency }}</td>
            <td v-if='financial.status == 2'>Not Approved</td>
            <td v-if='financial.status == 1'>Active</td>
            <td v-if='financial.status == 0'>Waiting Approval</td>
            <td v-if='financial.pay == 1'>Customer</td>
            <td v-if='financial.pay == 2'>Supplier</td>
            <td v-if='financial.pay == 3'>All</td>
            <td v-if='financial.pay == 4'>Direct</td>
            <td>{{financial.charge_at}}</td>
              <td><template v-if="financial.invoice_financials && parseInt(financial.invoice_financials.deleted) != 1 && parseInt(financial.invoice_financials.dispute) != 1"><tooltip :label="financial.invoice_financials.invoice.deadline" type="default" placement="top"><a @click="openInvoiceV2(financial.invoice_financials.invoice_id)">{{financial.invoice_financials.invoice_id}}</a></tooltip></template><template v-else>No</template>/<template v-if="financial.payment_financials && parseInt(financial.payment_financials.deleted) != 1 && parseInt(financial.payment_financials.dispute) != 1"><tooltip :label="financial.payment_financials.payment.deadline" type="default" placement="top"><a @click="openPaymentV2(financial.payment_financials.payment_id)">{{financial.payment_financials.payment_id}}</a></tooltip></template><template v-else>No</template></td>
            <td>
              <tooltip :label="financial.observation" type="default" placement="left">
                <a class="button button-table is-small">
                  <i class="fa fa-eye"></i>
                </a>
              </tooltip>
              <tooltip v-if="financial.pay === 4 && financial.status === 1 && financial.payment_financials && financial.type === 2" label="Card" type="default" placement="left">
                <a class="button button-table is-small" @click="showNewCard(financial)">
                  <i class="fa fa-credit-card"></i>
                </a>
              </tooltip>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </article>
  </div>
</template>

<script>
  import message from '../../utils/message'
  import Tooltip from 'vue-bulma-tooltip'
  import Datepicker from 'vue-bulma-datepicker'
  import Service from '../../components/services/services'
  import Invoice from '../finances/invoice'
  import Payment from '../finances/payment'
  import InvoiceV2 from '../finances/V2/invoice/invoice'
  import PaymentV2 from '../finances/V2/payment/payment'
  import InvoicePayment from '../finances/invoicePayment'
  import DebitsCredits from '../finances/debitsCredits'
  let date = new Date()
  export default {
    props: {
      service: {
        type: Object
      }
    },
    data () {
      return {
        financial: {
          id: '',
          pay: 0,
          observation: '',
          type: 1,
          gross_price: '',
          net_price: '',
          service_id: 0,
          charge_at: '',
          invoice: '',
          payment: '',
          service_date: '',
          currency: ''
        },
        error: '',
        financials: [],
        financialsV2: [],
        inProgress: false,
        operation: 'New Operation'
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
        this.$root.$on('reloadfinancial', reload => {
          this.loadData()
        })
      })
    },
    watch: {
      service: function (val) {
        let now = new Date()
        now.setHours(0, 0, 0)
        now = this.$moment(now).add(1, 'days')
        // let month = this.$moment(now).format('M')
        // let day = this.$moment(now).format('D')
        // let year = this.$moment(now).format('YYYY')
        // let minDate = ''
        // minDate = year + '-' + month + '-' + day + ' 00:00:00'
        this.$children[0].datepicker.set('minDate', new Date(this.service.service_date))
        this.$children[0].datepicker.setDate(new Date(now), true, 'Y-m-d')
      }
    },
    methods: {
      showNewCard (financial) {
        let propsData = {
          context: this,
          financial: financial,
          callback: 'showNewCardCallback'
        }
        Service.cardFinancial(propsData)
      },
      showNewCardCallback (result) {
        let propsData = {
          title: 'Success',
          message: 'The card was successfully sent',
          type: 'success',
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
        this.loadData(true)
      },
      parseSystem (content) {
        return parseInt(content.user_id) === 1 ? '*' : ''
      },
      skip (financial) {
        let propsData = {
          context: this,
          financial: financial,
          callback: 'skipDebitsCreditsCallback'
        }
        DebitsCredits.openSkipDebitsCredits(propsData)
      },
      skipDebitsCreditsCallback (result) {
        this.loadData(true)
      },
      setValidator () {
        switch (parseInt(this.financial.pay)) {
          case 0: {
            this.$validator.attach('gross_price', 'required|decimal')
            break
          }
          case 1: {
            this.$validator.detach('gross_price')
            break
          }
          case 2: {
            this.$validator.attach('gross_price', 'required|decimal')
            break
          }
        }
      },
      createInvoicePayment (financial) {
        let propsData = {
          context: this,
          financial: financial,
          hotel: this.service.room.hotel,
          callback: 'createInvoicePaymentCallback'
        }
        InvoicePayment.openCreateInvoicePayment(propsData)
      },
      createInvoicePaymentCallback (result) {
        this.message('success', 'Success', result)
        this.loadData()
      },
      showCreateInvoicePayment (financial) {
        if (((financial.invoice_financials === null) || (financial.payment_financials === null)) && parseInt(financial.refund) === 0) {
          return true
        } else {
          return false
        }
      },
      refresh (id) {
        this.$http.post(this.$store.state.config.apiURL + '/financials/refresh', {'financial_id': id}).then((response) => {
          this.message('success', 'Success', 'Financials refreshed')
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      },
      openInvoice (invoice) {
        let propsData = {
          context: this,
          invoice_id: invoice,
          edit: false,
          callback: ''
        }
        Invoice.openInvoice(propsData)
      },
      openPayment (payment) {
        let propsData = {
          context: this,
          payment_id: payment,
          edit: false,
          callback: ''
        }
        Payment.openPayment(propsData)
      },
      openInvoiceV2 (invoice) {
        let propsData = {
          context: this,
          invoice_id: invoice,
          edit: true,
          callback: ''
        }
        InvoiceV2.openInvoice(propsData)
      },
      openPaymentV2 (payment) {
        let propsData = {
          context: this,
          payment_id: payment,
          edit: true,
          callback: ''
        }
        PaymentV2.openPayment(propsData)
      },
      save () {
        this.inProgress = true
        this.financial.charge_at = this.$children[0].datepicker.input.value
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.$http.post(this.$store.state.config.apiURL + '/financials', this.financial).then((response) => {
              if (response.body.hasOwnProperty('error')) {
                this.error = response.body.description
                this.inProgress = false
              } else {
                this.message('success', 'Success', 'The operation was successfully registered')
                this.financial.id = ''
                this.financial.pay = 0
                this.financial.observation = ''
                this.financial.net_price = ''
                this.financial.gross_price = ''
                this.financial.type = 1
                this.financial.invoice = ''
                this.financial.payment = ''
                this.financial.currency = ''
                this.error = ''
                this.operation = 'New Operation'
                this.loadData()
                this.inProgress = false
              }
            }, (response) => {
              this.message('danger', 'Error', response.body)
            })
          } else {
            this.inProgress = false
          }
        })
      },
      show (what) {
        if ((parseInt(what.status) === 1)) {
          return true
        } else {
          return false
        }
      },
      loadData () {
        this.financial.service_id = this.service.id
        this.$http.get(this.$store.state.config.apiURL + '/financials/service/' + this.service.id).then((response) => {
          this.financials = response.body
          this.financials.status = 'Void'
          this.financials.editing = 'Edit'
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
        this.financial.charge_at = date
        this.$http.get(this.$store.state.config.apiURL + '/V2/financials/service/' + this.service.id).then((response) => {
          this.financialsV2 = response.body
        }, (response) => {
          this.message('danger', 'Error', response.body)
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      editOperation (ido) {
        this.operation = 'Edit Operation'
        for (var i = 0; i < this.financials.length; i++) {
          if (this.financials[i].id === ido) {
            this.financial.id = ido
            this.financial.pay = this.financials[i].pay
            this.financial.observation = this.financials[i].observation
            this.financial.net_currency = this.financials[i].net_currency
            this.financial.net_price = this.financials[i].net_price
            this.financial.gross_currency = this.financials[i].gross_currency
            this.financial.gross_price = this.financials[i].gross_price
            this.financial.service_id = this.financials[i].service_id
            this.financial.type = this.financials[i].type
            this.financial.user_id = this.financials[i].user_id
            this.financial.currency = this.financials[i].net_currency
          }
        }
      },
      voided (ido) {
        if (window.confirm('Are you sure you want to VOID this?')) {
          this.$http.post(this.$store.state.config.apiURL + '/financials/void', {id: ido}).then((response) => {
            if (response.body.hasOwnProperty('error')) {
              this.error = response.body.description
              this.inProgress = false
            } else {
              this.message('success', 'Success', 'The operation was successfully registered')
              this.loadData()
            }
          }, (response) => {
            this.message('danger', 'Error', response.body)
          })
        }
      }
    },
    components: {
      Datepicker,
      Tooltip,
      Service
    }
  }
</script>

<style lang="scss" scoped>
  pre {
    background-color: #FFFFFF;
    white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
    white-space: -pre-wrap; /* Opera */
    white-space: -o-pre-wrap; /* Opera */
    white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
    word-wrap: break-word; /* IE 5.5+ */
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
    color: #4a4a4a;
    font-size: 1rem;
    font-weight: 400;
  }
</style>



// WEBPACK FOOTER //
// Financial.vue?6c085bf0